module.exports = __webpack_public_path__ + "static/img2-e1c118a5970460e94531007e61534541.png";